import { useMemo, useState } from 'react';
import styles from './AddOnCard.module.scss';

export default function AddOnDescription({
  description,
}: Readonly<{ description: string }>) {
  const [isFullDescriptionVisible, setIsFullDescriptionVisible] =
    useState(false);
  const buttonLabel = isFullDescriptionVisible ? 'View less' : 'View more';
  const wordCount = description?.split(' ').length;

  const desc = useMemo(() => {
    if (wordCount > 20 && !isFullDescriptionVisible) {
      return description.split(' ').slice(0, 14).join(' ') + '...';
    }

    return description;
  }, [description, isFullDescriptionVisible, wordCount]);

  const viewButtonIsVisible = wordCount > 20;

  return (
    <div className={styles.description}>
      <div dangerouslySetInnerHTML={{ __html: desc }} />
      {viewButtonIsVisible ? (
        <button
          className={styles.viewButton}
          onClick={() => setIsFullDescriptionVisible(!isFullDescriptionVisible)}
        >
          {buttonLabel}
        </button>
      ) : null}
    </div>
  );
}
